/*!
=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// javascipt plugin for creating charts
import Chart from "chart.js";
// node.js library that concatenates classes (strings)
import React from "react";
import {Bar, Line} from "react-chartjs-2";
// react plugin used to create charts
// reactstrap components
import {
    Button,
    Card,
    CardBody, CardText,
    CardTitle,
    Col,
    Container, DropdownItem, DropdownMenu,
    DropdownToggle, Modal, Nav, NavItem, NavLink,
    Progress,
    Row, Table,
    UncontrolledDropdown,
} from "reactstrap";
import {chartOptions, parseOptions,} from "../variables/adminCharts";

import '../assets/css/heroBanner.css';
import _ from "lodash";
import ReviewService from "../services/reviewService";
import UtilService from "../services/utilService";
import DownloadUtil from "../util/downloadUtil";
import Rating from "react-rating";
import formatFrontendDate from "../views/pages/util/formatFrontendDate";
import BreakdownScoreMultiLineChart from "../views/pages/reviews/BreakdownScoreMultiLineChart";
import CardFooter from "reactstrap/es/CardFooter";
import FormInput from "../components/common/form/FormInput";
import BreakdownScoreBarGraph from "../views/pages/reviews/BreakdownScoreBarGraph";
import AppNavBar from "./AppNavBar";
import NotificationAlert from "react-notification-alert";
import Login from "./pages/auth/Login";
import Contactus from "../components/ContactUs";

const items = [
    {
        src: 'https://picsum.photos/id/123/1200/400',
        altText: 'Slide 1',
        caption: 'Slide 1',
        key: 1,
    },
    {
        src: 'https://picsum.photos/id/456/1200/400',
        altText: 'Slide 2',
        caption: 'Slide 2',
        key: 2,
    },
    {
        src: 'https://picsum.photos/id/678/1200/400',
        altText: 'Slide 3',
        caption: 'Slide 3',
        key: 3,
    },
];


class CompanyProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeNav: 1,
            chartExample1Data: "data1",
            activeIndex: 0,
            animating: false,
            score: 0,
            totalReviewsSent: 0,
            totalUnansweredReviews: 0,
            totalAnsweredReviews: 0,
            breakDownScore: {},
            breakDownChartKey: UtilService.uuidv4(),
            breakDownBarKey: UtilService.uuidv4(),
            dateFrom: null,
            dateTo: null,
            companyUniqueId: this.props.match.params.uniqueId,
            loginModal: false,
            companyDescription : ""

        };
        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
        this.filterByContentType = this.filterByContentType.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this)
    }

    filterByContentType = (data, type) => {
        return _.filter(data, {contentType: type});
    };

    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };


    next = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({activeIndex: nextIndex})
    };

    previous = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
        this.setState({activeIndex: nextIndex})
    };

    goToIndex = (newIndex) => {
        if (this.state.animating) return;
        this.setState({activeIndex: newIndex})
    };

    componentDidMount() {
        ReviewService.userReviewDetails(this.state.companyUniqueId).then((response) => {
            this.setState({...response, breakDownBarKey : UtilService.uuidv4()});
            console.log(response);
        })
        ReviewService.companyDescription(this.state.companyUniqueId).then(response => {
            console.log(response)
            this.setState({companyDescription:response.companyDescriptionMarkup})
        })
    }

    getColor = (score) => {
        if (score >= 4) {
            return "green";
        } else if (score > 2) {
            return "orange";
        } else if (score > 0) {
            return "red";
        } else {
            return "red"
        }
    };
    applyDateFilter = () => {
        const data = {dateFrom: this.state.dateFrom, dateTo: this.state.dateTo};
        ReviewService.historicDataForCurrentUser(data).then(response => {
            this.setState({historicData: response, breakDownChartKey: UtilService.uuidv4()});
        })
    }

    clearDateFilter = () => {
        ReviewService.historicDataForCurrentUser().then(response => {
            this.setState({historicData: response, breakDownChartKey: UtilService.uuidv4(),
                dateFrom: null, dateTo: null});
        })
    }

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index,
            chartExample1Data:
                this.state.chartExample1Data === "data1" ? "data2" : "data1",
        });
    };

    onChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }


    render() {
        return (
            <>

                {/*Nav Bar*/}
                <AppNavBar loginModalToggle={this.toggleModal}/>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {/* Hero Banner */}
                <div className="hero-banner" style={{height: "256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Trust Score</p>
                                    <h1 style={{textAlign: "start"}}>{this.state.companyName}</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container className="mt-6" fluid>
                    <Row className="justify-content-center">
                        <Col xs="12" md="10" lg="9"> {/* Control left/right space here */}

                            {/* Ratings Card */}
                            <Row
                                key={UtilService.uuidv4()}
                                className="align-items-lg-start mb-4 p-3 border rounded"
                                style={{ backgroundColor: "#f8f9fe" }}
                            >
                                {/* Column 1: Logo */}
                                <Col xs="12" md="2" className="text-center mb-3 mb-md-0">
                                    <img
                                        src={
                                            this.state.brandLogoUID === null
                                                ? require("assets/img/brand/companies.jpeg")
                                                : this.state.brandLogoUID && DownloadUtil.generateUrl(this.state.brandLogoUID)
                                        }
                                        alt="Company Logo"
                                        style={{ width: "128px", height: "156px", objectFit: "contain" , marginTop: "-8px"}}
                                    />
                                </Col>

                                {/* Column 2: Company Name and Score */}
                                <Col xs="12" md="3" className="mb-3 mb-md-0">
                                    <h4 className="font-weight-bold">
                                        <b>{this.state.companyName}</b>
                                    </h4>
                                    <p>Average Score: {this.state.score?.toFixed(1) ?? "0.0"}/5</p>
                                    <Rating
                                        readonly
                                        initialRating={this.state.score}
                                        emptySymbol={<i className="fa fa-star text-muted" />}
                                        fullSymbol={<i className="fa fa-star text-warning" />}
                                        fractions={2}
                                        title={this.state.score?.toFixed(1)}
                                    />
                                    <p>Total Reviews - ({this.state.breakDownScore?.totalReviews || 0})</p>
                                </Col>

                                {/* Column 3: Review Count and Breakdown */}
                                <Col xs="12" md="6">
                                    {this.state.breakDownScore?.breakdown?.length > 0 ? (
                                        <Row>
                                            {this.state.breakDownScore.breakdown.map((entry) => (
                                                <Col key={UtilService.uuidv4()} xs="12" sm="12" className="mb-2">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span style={{ fontSize: "0.9rem" }}>{entry.question}:</span>
                                                        <span style={{ whiteSpace: "nowrap", marginLeft: "0.5rem" }}>
                      <Rating
                          readonly
                          initialRating={entry.breakdownScore}
                          emptySymbol={<i className="fa fa-star text-muted" />}
                          fullSymbol={<i className="fa fa-star text-warning" />}
                          fractions={2}
                          title={entry.breakdownScore.toFixed(1)}
                      />
                      <span className="ml-2">{entry.breakdownScore.toFixed(1)}/5</span>
                    </span>
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>
                                    ) : (
                                        <p className="text-muted mt-2">No breakdown available</p>
                                    )}
                                </Col>
                            </Row>

                            {/* Testimonials */}
                            {_.filter(
                                this.state.breakDownScore?.remarks,
                                (remark) => remark?.showAsTestimonial && remark?.remarkPublic
                            ).length > 0 && (
                                <>
                                    <h1>Testimonials</h1>
                                    <Row>
                                        {this.state.breakDownScore?.remarks?.map((value, index) => (
                                            <Col
                                                xs="12"
                                                md="6"
                                                lg="4"
                                                className="mb-4"
                                                key={index}
                                                style={{
                                                    display:
                                                        value?.remarkPublic && value?.showAsTestimonial ? "" : "none",
                                                }}
                                            >
                                                <Card className="shadow-sm h-100 border border-gray">
                                                    <CardBody style={{    backgroundColor: "#50617a"}}>
                                                        <CardText
                                                            style={{ whiteSpace: "normal", wordBreak: "break-word", color:"white", fontSize: "1.1rem" }}
                                                        >
                                                            "{value?.remark}"
                                                        </CardText>
                                                        <CardTitle
                                                            tag="h6"
                                                            className="mt-3 mb-0"
                                                            style={{ fontSize: "1.1rem", float: "right" , color:"white"}}
                                                        >
                                                            —{value?.contact?.firstName} {value?.contact?.lastName}
                                                        </CardTitle>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                    <Row>
                                        <br/>
                                        <br/>
                                        <br/>
                                        {this.state.isPartner && <Contactus showChart={"none"}/>}
                                    </Row>
                                    <hr style={{ backgroundColor: "#e57a74", height: "1px" }} />
                                </>
                            )}


                            {/* Description */}
                            {this.state.companyDescription && (
                                <>
                                    <h1>About the Company</h1>
                                    <h3 dangerouslySetInnerHTML={{ __html: this.state.companyDescription }}></h3>
                                </>
                            )}



                        </Col>
                    </Row>
                    <Row>
                        <br/>
                        <br/>
                        <br/>
                        {this.state.isPartner && <Contactus showChart={"none"}/>}
                    </Row>

                </Container>


                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>


            </>
        );
    }
}

export default CompanyProfile;
